// AUTO-GENERATED SEED barrel — review + reshape.
import { createRegistry } from '@auctogon/core/api/registry';
import { auctions } from './auctions';
import { auth } from './auth';
import { cron } from './cron';
import { conversations } from './conversations';
import { customers } from './customers';
import { files } from './files';
import { inbox } from './inbox';
import { internal } from './internal';
import { internal_notes } from './internal_notes';
import { inventory } from './inventory';
import { invoices } from './invoices';
import { invite } from './invite';
import { invites } from './invites';
import { ledger_entries } from './ledger_entries';
import { locations } from './locations';
import { lots } from './lots';
import { notification_templates } from './notification_templates';
import { offline } from './offline';
import { offline_reference } from './offline_reference';
import { payment_instruments } from './payment_instruments';
import { payments } from './payments';
import { publicRoutes } from './public';
import { realtime } from './realtime';
import { sales_reps } from './sales_reps';
import { settlements } from './settlements';
import { transactions } from './transactions';
import { super_admin } from './super_admin';
import { tenants } from './tenants';
import { terms_documents } from './terms_documents';
import { time } from './time';
import { user } from './user';
import { webhooks } from './webhooks';

export const adminRegistry = createRegistry({
  auctions,
  auth,
  cron,
  conversations,
  customers,
  files,
  inbox,
  internal,
  internal_notes,
  inventory,
  invoices,
  invite,
  invites,
  ledger_entries,
  locations,
  lots,
  notification_templates,
  offline,
  offline_reference,
  payment_instruments,
  payments,
  public: publicRoutes,
  realtime,
  sales_reps,
  settlements,
  transactions,
  super_admin,
  tenants,
  terms_documents,
  time,
  user,
  webhooks,
});
